import styled from "styled-components";

import type { Lesson, Part, Translation } from "api/services/content/schemas/lessons";
import { SmartphonePreview } from "shared/atoms/SmartphonePreview";

import { LessonScreen } from "./LessonScreen";
import { QuizScreen } from "./QuizScreen";
import type { SelectedScreen } from "./ScreenSelector";

export type TranslationSubset = Pick<Translation, "content" | "image_url" | "questions" | "title">;
type PartSubset = Pick<Part, "questions"> & { translation: TranslationSubset };
export type LessonSubset = Pick<Lesson, "target_joints"> & { parts: PartSubset[] };
interface Props {
  lesson: LessonSubset;
  selectedScreen: SelectedScreen;
}

export const LessonPreviewMobile: React.FC<Props> = ({ lesson, selectedScreen }) => {
  const { parts } = lesson;
  const { questions, translation } = parts[0];
  const { index, screen } = selectedScreen;

  const getScreen = () => {
    switch (screen) {
      case "text_lesson":
        return <LessonScreen translation={translation} />;
      case "quiz":
        return <QuizScreen index={index} question={translation.questions[index]} total={questions.length} />;
      default:
        return null;
    }
  };

  return <StyledSmartphonePreview $selectedScreen={screen}>{getScreen()}</StyledSmartphonePreview>;
};

const StyledSmartphonePreview = styled(SmartphonePreview)<{ $selectedScreen: SelectedScreen["screen"] }>`
  & .smartphone_preview-content {
    padding: 56px 0 0;
    background: ${({ theme, $selectedScreen }) =>
      $selectedScreen === "text_lesson" ? theme.colors.redesign.t10 : "none"};
  }
`;
